module.exports = __webpack_public_path__ + "media/images/logo_skyc-1588ab7946abaadc83f9a22d21066776.png";